// extracted by mini-css-extract-plugin
module.exports = {"pathFill":"LoadingSpinner_pathFill__FpFKx","dash":"LoadingSpinner_dash__OXVNg"};